import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { getJobBoardByJBName, IJobBoardDTO } from 'wisestep-api';

import SettingsIndex from '../../../../components/SettingsIndex';
import { useNativeSearchQueryStore } from '../store/NativeSearchQueryStore';
export interface BadgeCountType {
  dice: number;
  cbRDB: number;
  cbEdge: number;
  techFetch: number;
  cvLibrary: number;
  resumeLibrary: number;
  monster: number;
  jobServe: number;
  jobSite: number;
  cwJobs: number;
}

const NativeSearchIndex = () => {
  const [badgeCount, setBadgeCount] = useState<BadgeCountType>({
    dice: 0,
    cbRDB: 0,
    cbEdge: 0,
    techFetch: 0,
    cvLibrary: 0,
    resumeLibrary: 0,
    monster: 0,
    jobServe: 0,
    jobSite: 0,
    cwJobs: 0,
  });
  const setEmail = useNativeSearchQueryStore((state) => state.setEmail);

  useEffect(() => {
    const fetchJobBoardAcc = async () => {
      setEmail('');
      const response = await getJobBoardByJBName('all');
      const jobBoardData = response.data;
      setBadgeCount({
        dice:
          jobBoardData.filter((data: IJobBoardDTO) => data.jobBoardName === 'DICE_SEARCH').length ??
          0,
        cbRDB:
          jobBoardData.filter((data: IJobBoardDTO) => data.jobBoardName === 'CAREER_BUILDER')
            .length ?? 0,
        cbEdge:
          jobBoardData.filter((data: IJobBoardDTO) => data.jobBoardName === 'CAREER_BUILDER_EDGE')
            .length ?? 0,
        techFetch:
          jobBoardData.filter((data: IJobBoardDTO) => data.jobBoardName === 'TECH_FETCH').length ??
          0,
        cvLibrary:
          jobBoardData.filter((data: IJobBoardDTO) => data.jobBoardName === 'CV_LIBRARY').length ??
          0,
        resumeLibrary:
          jobBoardData.filter((data: IJobBoardDTO) => data.jobBoardName === 'RESUME_LIBRARY')
            .length ?? 0,
        monster:
          jobBoardData.filter((data: IJobBoardDTO) => data.jobBoardName === 'MONSTER').length ?? 0,
        jobServe:
          jobBoardData.filter((data: IJobBoardDTO) => data.jobBoardName === 'JOB_SERVE').length ??
          0,
        jobSite:
          jobBoardData.filter((data: IJobBoardDTO) => data.jobBoardName === 'JOB_SITE').length ?? 0,
        cwJobs:
          jobBoardData.filter((data: IJobBoardDTO) => data.jobBoardName === 'CW_JOBS').length ?? 0,
      });
    };
    fetchJobBoardAcc();
  }, [setBadgeCount, setEmail]);

  const jobBoardsList = [
    {
      label: 'Dice',
      url: '/native-search-settings/',
      count: badgeCount.dice,
    },
    {
      label: 'Career Builder RDB',
      url: '/native-search-settings/cb-rdb',
      count: badgeCount.cbRDB,
    },
    {
      label: 'Career Builder Edge',
      url: '/native-search-settings/cb-edge',
      count: badgeCount.cbEdge,
    },
    {
      label: 'Tech Fetch',
      url: '/native-search-settings/techFetch',
      count: badgeCount.techFetch,
    },
    {
      label: 'CV Library',
      url: '/native-search-settings/cv-library',
      count: badgeCount.cvLibrary,
    },
    {
      label: 'Resume Library',
      url: '/native-search-settings/resume-library',
      count: badgeCount.resumeLibrary,
    },
    {
      label: 'Monster',
      url: '/native-search-settings/monster',
      count: badgeCount.monster,
    },
    {
      label: 'Job Serve',
      url: '/native-search-settings/job-serve',
      count: badgeCount.jobServe,
    },
    {
      label: 'Job Site',
      url: '/native-search-settings/job-site',
      count: badgeCount.jobSite,
    },
    {
      label: 'CW Jobs',
      url: '/native-search-settings/cw-job',
      count: badgeCount.cwJobs,
    },
  ];

  return (
    <Box borderRadius={1.5}>
      <SettingsIndex options={jobBoardsList} />
    </Box>
  );
};

export default NativeSearchIndex;
